import { useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormGroup,
  FormLabel,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";

import moment from "moment";
import DateField from "components/_refactor/fields/date";
import UtilsFncs from "utils/UtilsFncs";
import PerfectScrollbar from "react-perfect-scrollbar";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";

function DialogCreateReminder({
  open,
  onClose,
  cpf,
  idLoja,
  idVendedor,
  customerDetail,
  setHasUpdatedReminders,
}) {
  const snackbar = useSnackbar();
  const [submitting, setSubmitting] = useState(false);
  const [initialDate, setInitialDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [reason, setReason] = useState("");
  const [tip, setTip] = useState("");

  const formatPhone = customerDetail?.Celular?.replace(/[^\d]+/g, "");
  const number = formatPhone?.substring(2);
  const ddd = formatPhone?.substring(0, 2);

  const handleClearFinalDate = () => {
    document.getElementById("#buttonClearFinalDate").click();
  };

  const handleClose = () => {
    onClose();
  };

  const handleCreateReminder = async () => {
    setSubmitting(true);

    await Api.post(
      "create-user-reminders",
      "action",
      {
        Cpf: cpf?.replace(/\D/g, ""),
        IdPessoaLoja: idLoja?.toString(),
        DataInicio: initialDate,
        DataFim: finalDate,
        Motivo: reason,
        Dica: tip,
        Nome: customerDetail?.Nome,
        Ddd: ddd,
        Telefone: number,
        IdLojaVendedor: idVendedor,
      },
      true
    )
      .then((res) => {
        if (res?.Success) {
          snackbar.showMessage(`Lembrete registrado com sucesso!`, {
            severity: "success",
          });
          setHasUpdatedReminders(true);
          setInitialDate("");
          setFinalDate("");
          setReason("");
          setTip("");
          handleClose();
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>
          <Typography id="alert-dialog-title" variant="h3" component="h3">
            Cadastro de Lembrete
          </Typography>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent style={{ padding: "1rem 1.5rem 5rem" }}>
            <Grid container>
              <Grid item xs={12}>
                <FormGroup style={{ width: "100%" }}>
                  <DateField
                    label="Data Inicial"
                    value={initialDate}
                    onChange={(value) => {
                      handleClearFinalDate();
                      setInitialDate(value);
                      setFinalDate("");
                    }}
                    disabled={submitting}
                    required={false}
                    isValidDate={(current) => {
                      const today = moment().format("YYYY-MM-DD");
                      return current.format("YYYY-MM-DD") >= today;
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <FormGroup style={{ width: "100%" }}>
                  <DateField
                    label="Data Final"
                    value={finalDate}
                    onChange={(value) => {
                      setFinalDate(value);
                    }}
                    disabled={submitting}
                    required={false}
                    isValidDate={(current) => {
                      const currentDate = current.format("YYYY-MM-DD");
                      return (
                        currentDate >=
                        UtilsFncs.ConvertDateFormat(initialDate, "/", "-")
                      );
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Motivo</FormLabel>
                  <TextField
                    name="motivo"
                    type={"text"}
                    multiline
                    fullWidth
                    disabled={submitting}
                    value={reason}
                    variant="outlined"
                    onChange={(e) => setReason(e.target.value)}
                    onInput={(e) => {
                      e.target.value = e.target.value.toString().slice(0, 300);
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>Dica</FormLabel>
                  <TextField
                    name="tip"
                    type={"text"}
                    multiline
                    fullWidth
                    disabled={submitting}
                    value={tip}
                    variant="outlined"
                    onChange={(e) => setTip(e.target.value)}
                    onInput={(e) => {
                      e.target.value = e.target.value.toString().slice(0, 300);
                    }}
                  />
                </FormGroup>
              </Grid>
            </Grid>
            {submitting && (
              <div>
                <span>Registrando lembrete...</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
        </PerfectScrollbar>
        <DialogActions>
          <Button component={Box} onClick={handleClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button
            color="default"
            variant="contained"
            type="button"
            disabled={
              submitting ||
              initialDate === "" ||
              finalDate === "" ||
              tip === "" ||
              reason === ""
            }
            onClick={handleCreateReminder}
          >
            {submitting ? "Registrando..." : "Registrar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export { DialogCreateReminder };
